import { routes as app } from '../app/index'

export default [...app]
